// capitalizationのメタデータ保存処理
import { apiEndPoint } from "./endPoint";

interface capitalizationDataType {
  userId: string;
  conversationId: string;
  date: string;
  complete: boolean;
  threadId?: string;
}

export const putCapitalizationData = async (
  capitalizationData: capitalizationDataType,
  token: string
) => {
  const url = `${apiEndPoint}/putMetaData`;

  const putData = capitalizationData;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(putData),
    });

    if (response.ok) {
      const responseData = await response.json();
      console.log(response);
      return responseData;
    } else {
      throw new Error("Failed to fetch");
    }
  } catch (err) {
    console.error("Error:", err);
    return {
      role: "error",
      content: "エラーが発生したようです。初めからやり直してください。",
    };
  }
};
